( () => {
    const $headerBars = document.querySelectorAll('.header-bars');

    console.log($headerBars);

    if ( $headerBars.length ) {
        $headerBars.forEach( $header => {
            $header.innerHTML = $header.innerHTML.replace(/(^|<\/?[^>]+>|\s+)([^\s<]+)/g, '$1<span class="word">$2</span> ');
        } );
    }
} )();
